import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZz = (props) => /* @__PURE__ */ _jsx("svg", {
	"data-icon": "zz",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 4.35714H5.36264V4.45604L2 9.4011V9.5H5.36264M7.14282 2H9.75821V2.07692L7.14282 5.92308V6H9.75821",
		stroke: "#636C7B",
		strokeWidth: .8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgZz;
